import React from 'react';
import classNames from 'classnames';

import { POPULAR_NICHES_ID_LIST } from 'rebook/apps/catalog/constants';
import ContentCarousel from 'rebook/apps/base/components/ContentCarousel';
import CatalogNicheItem from 'rebook/apps/catalog/components/CatalogNicheItem';

import styles from './style.scss';


const NicheCatalogPopularList = ({ niches }) => {
  const popularNiches = [];

  if (niches) {
    POPULAR_NICHES_ID_LIST.map((id) => {
      const matchedNiche = niches.filter((niche) => niche.id === id);
      matchedNiche && popularNiches.push(matchedNiche[0]);
    });
  }

  return (
    <div className={classNames('billetContainerNoOverflow', styles.popularNicheList)}>
      {popularNiches.length > 0
        ? (
          <React.Fragment>
            <div className="billetContainerWrapper">
              <div className={classNames('title-2', styles.title)}>Популярные жанры</div>
            </div>
            <ContentCarousel withNav>
              {popularNiches.map((niche) => {
                return niche && (
                  <div className={classNames('swiper-slide', styles.nicheCarouselItem)} key={niche.id}>
                    <CatalogNicheItem niche={niche} />
                  </div>
                );
              })}
            </ContentCarousel>
          </React.Fragment>
        )
        : (
          <div className={styles.nicheListEmpty}>
            <div className="billetContainerWrapper">
              <div className={styles.nameEmpty} />
            </div>
            <ContentCarousel withNav>
              {[...Array(6)].map((item, key) => (
                <div className={classNames('swiper-slide', styles.nicheCarouselItemEmpty)} key={key} />
              ))}
            </ContentCarousel>
          </div>
        )
      }
    </div>
  );
};

export default NicheCatalogPopularList;
